export default __webpack_public_path__ + "static/media/Truck_Power_Only_Icon.a0c22fa2.svg";